export default {"src":"/_next/static/media/logo-supersitters-black.00a16784.svg","height":346,"width":974,"blurWidth":0,"blurHeight":0};